import produce from 'immer';
import at from 'lodash-es/at';
import isPlainObject from 'lodash-es/isPlainObject';
/**
 * PMA = Promise Middleware Aware
 */
var EMPTY_ID = '__EMPTY_ID__';
export var PMA_PENDING = 'PENDING';
export var PMA_FULFILLED = 'FULFILLED';
export var PMA_REJECTED = 'REJECTED';
export var PMA_NONE = 'NONE';
//
export var pmaTypePending = function (type) { return "".concat(type, "_").concat(PMA_PENDING); };
export var pmaTypeFulfilled = function (type) { return "".concat(type, "_").concat(PMA_FULFILLED); };
export var pmaTypeRejected = function (type) { return "".concat(type, "_").concat(PMA_REJECTED); };
//
export var is404 = function (error) { return error && 404 === at(error, ['response.status'])[0]; };
export var isUnauthorized = function (error) {
    return error && 401 === at(error, ['response.status'])[0];
};
export var isForbidden = function (error) { return error && 403 === at(error, ['response.status'])[0]; };
//
export var pmaIsPendingSelector = function (state) {
    return function (id) {
        id = pmaNormalizeId(id || EMPTY_ID);
        return state.log[id] ? state.log[id].type === PMA_PENDING : false;
    };
};
export var pmaIsFulfilledSelector = function (state) {
    return function (id) {
        id = pmaNormalizeId(id || EMPTY_ID);
        return state.log[id] ? state.log[id].type === PMA_FULFILLED : false;
    };
};
export var pmaIsRejectedSelector = function (state) {
    return function (id) {
        id = pmaNormalizeId(id || EMPTY_ID);
        return state.log[id] ? state.log[id].type === PMA_REJECTED : false;
    };
};
// pouzivam slova "status" namiesto "state" (z finite state machine) aby sa nebilo so redux state-om
export var pmaStatusSelector = function (state) {
    return function (id) {
        if (pmaIsPendingSelector(state)(id)) {
            return PMA_PENDING;
        }
        if (pmaIsFulfilledSelector(state)(id)) {
            return PMA_FULFILLED;
        }
        if (pmaIsRejectedSelector(state)(id)) {
            return PMA_REJECTED;
        }
        return PMA_NONE;
    };
};
export var pmaLastErrorSelector = function (state) {
    return function (id) {
        id = pmaNormalizeId(id || EMPTY_ID);
        if (pmaIsRejectedSelector(state)(id)) {
            return state.log[id].payload;
        }
        return null;
    };
};
export var pmaLastFulfilledSelector = function (state) {
    return function (id) {
        id = pmaNormalizeId(id || EMPTY_ID);
        if (pmaIsFulfilledSelector(state)(id)) {
            return state.log[id].payload;
        }
        return null;
    };
};
// toto trosku hackujem, lebo si chcem nejak normalizovane znacit podla custom
// idecka co bolo fullfilnute... je to ok, akurat toto musim volat manualne...
export var pmaTypeFulfilledMark = function (type) { return "".concat(type, "_FULFILLED_MARK"); };
export var pmaTypeRejectedMark = function (type) { return "".concat(type, "_REJECTED_MARK"); };
export var pmaTypeMarkReset = function (type) { return "".concat(type, "_MARK_RESET"); };
export var pmaMarkFulfilled = function (type, payload, id) { return ({
    type: pmaTypeFulfilledMark(type),
    payload: { id: id, payload: payload },
}); };
export var pmaResetExistingMark = function (type, id) { return ({
    type: pmaTypeMarkReset(type),
    payload: { id: id },
}); };
export var pmaMarkRejected = function (type, error, threadId) { return ({
    type: pmaTypeRejectedMark(type),
    payload: { id: threadId, threadId: threadId, error: error },
}); };
var pmaCreateInitialState = function () { return ({
    isPending: false,
    isFulfilled: false,
    isRejected: false,
    timestamp: new Date(),
    log: {},
}); };
/**
 * @param value
 */
export var pmaNormalizeId = function (value) {
    if (Array.isArray(value)) {
        // note: tu robit sort moze ale NEMUSI byt ziaduce!
        return value.join('-');
    }
    if (isPlainObject(value)) {
        return Object.keys(value)
            .sort()
            .reduce(function (memo, k) {
            memo.push("".concat(k, ":").concat(value[k])); // memo.push(value[k]);
            return memo;
        }, [])
            .join('-');
    }
    // all others (strings, numbers, ...) return without change...
    return value;
};
/**
 * @param actionType
 */
export var pmaCreateReducer = function (actionType) {
    return produce(function (state, action) {
        var now = new Date();
        var getId = function () {
            var id = (action.payload || {}).id;
            return pmaNormalizeId(id || EMPTY_ID); // je legitimne, ze id pri niektorych calloch neexistuje
        };
        switch (action.type) {
            // case PMATypeReset(actionType):
            //     return createPMAInitialState();
            case pmaTypePending(actionType):
                state.isRejected = false;
                state.isFulfilled = false;
                delete state.error;
                state.isPending = true;
                state.timestamp = now;
                state.payload = action.payload;
                // note: action.payload su tu "optimistic data"... (je to trosku hidden vec)
                // note: iba tu by malo byt skutocne potrebe ist via getId(), inde sme safe
                state.log[getId()] = { type: PMA_PENDING, timestamp: now };
                break;
            case pmaTypeFulfilled(actionType):
                state.isPending = false;
                state.isRejected = false;
                delete state.error;
                state.isFulfilled = true;
                state.timestamp = now;
                state.payload = action.payload;
                break;
            // trosku hack aby som mal ulozene normalizovane idecke pre fullfil
            case pmaTypeFulfilledMark(actionType):
                state.log[getId()] = {
                    type: PMA_FULFILLED,
                    timestamp: now,
                    payload: action.payload.payload,
                };
                break;
            case pmaTypeRejected(actionType):
                state.isPending = false;
                state.isFulfilled = false;
                delete state.payload;
                state.isRejected = true;
                state.timestamp = now;
                state.error = action.payload;
                break;
            case pmaTypeRejectedMark(actionType):
                state.log[getId()] = {
                    type: PMA_REJECTED,
                    timestamp: now,
                    payload: action.payload.error,
                };
                break;
            case pmaTypeMarkReset(actionType):
                delete state.log[getId()];
                break;
        }
    }, pmaCreateInitialState());
};
/**
 * @param state
 */
export var pmaCreateSelector = function (state) { return ({
    isPending: pmaIsPendingSelector(state),
    isFulfilled: pmaIsFulfilledSelector(state),
    isRejected: pmaIsRejectedSelector(state),
    status: pmaStatusSelector(state),
    lastFulfilled: pmaLastFulfilledSelector(state),
    lastError: pmaLastErrorSelector(state),
}); };
